import { defineAsyncComponent } from 'vue'

import type { ReportLayoutConfig, SectionBuild } from '@/features/reports'

const RFM_REPORT_ID = 67

const rfmSegmentsBuild: SectionBuild = () => ({
  id: '67-rfm-segments',
  reportId: RFM_REPORT_ID,
  scheduleTabs: ['overview'],
  dimensions: [
    'customer_id',
    'rfm_segment',
    'recency_segment',
    'monetary_segment',
    'frequency_segment',
  ],
})

export const RFM_CLUSTERING: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'audience.rfm.tabs.overview',
    sections: [
      {
        id: '67-rfm-segments',
        titleKey: 'audience.rfm.segments',
        reportId: RFM_REPORT_ID,
        hideChannels: true,
        build: rfmSegmentsBuild,
        tabs: [{ name: 'RFM Segments', reportId: RFM_REPORT_ID, tabs: ['overview'] }],
      },
      {
        id: '67-rfm-chart',
        titleKey: 'audience.rfm.segments',
        reportId: RFM_REPORT_ID,
        component: defineAsyncComponent(() => import('../components/rfm/RfmSegmentTreemap.vue')),
        tabs: [{ name: 'RFM Segments', reportId: RFM_REPORT_ID, tabs: ['overview'] }],
      },
    ],
  },
]
